import React from "react";
import { Box, Container, Typography } from "@mui/material";
import "./SloganSection.css";

const SloganSection = () => {
  return (
    <Box className="slogan-section">
      <div className="slogan-overlay"></div>
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
        <Box className="slogan-content">
          <Typography
            variant="h3"
            component="h2"
            className="slogan-quote"
            sx={{
              fontFamily: "'Playfair Display', serif",
              fontWeight: 700,
              fontStyle: "italic",
              mb: 3,
            }}
          >
            “Beyond structures, we build futures. Your vision, built with
            passion.”
          </Typography>

          {/* <div className="slogan-divider"></div>

          <Typography
            variant="h5"
            className="slogan-tagline"
            sx={{
              fontFamily: "'Montserrat', sans-serif",
              letterSpacing: "2px",
              textTransform: "uppercase",
              mt: 2,
            }}
          >
            We are builders — build with{" "}
            <span className="highlight-text">VR Builders & Promoters</span>.
          </Typography>  */}
        </Box>
      </Container>
    </Box>
  );
};

export default SloganSection;
